import React from 'react'
import { useTranslation } from 'react-i18next'

import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import { useCloseModal } from '../../../components/modals/ModalsContext'

export default function ExecButton({ loading, error }) {
  const { t } = useTranslation('editStocks')
  const form = useForm()
  const onClose = useCloseModal()

  const notAllSuccess = form.find(i => i.status !== 'success')

  return (
    <Separator paddingH={2} marginV={1}>
      {!!notAllSuccess && <SubmitBar loading={loading} error={error} label={t('bulkTransfer.actions.execute')} />}

      {!notAllSuccess && (
        <SubmitBar loading={loading} error={error} label={t('bulkTransfer.actions.close')} onClick={onClose} />
      )}
    </Separator>
  )
}
